export function loadAccessibilityWidget(): void {
  const script = document.createElement("script");
  script.src = "https://widget.tabnav.com/limited-widget.min.js.gz";
  script.defer = true;
  script.setAttribute(
    "tnv-data-config",
    JSON.stringify({
      language: "he",
      color: "#757575",
      buttonColor: "#2e2e2e",
      buttonSize: "small",
      widgetSize: "small",
      widgetLocation: "left",
      buttonLocation: "bottom",
    })
  );
  document.head.appendChild(script);

  const noscript = document.createElement("noscript");
  noscript.innerHTML =
    'מידע על תוסף הנגישות:<a href="https://tabnav.com/he/pricing/accessibility-widget">הנגשת אתרים מחיר</a>';
  document.body.appendChild(noscript);
}
